import React from 'react';
import { withTranslations, WithTranslationsProps } from 'react-utilities';
import { TRANSLATION_CONFIG } from './app.config';
import { DismissOption, PromptType, ViewType } from './constants/parameters';
import AccountSecurityPromptContainer from './containers/accountSecurityPrompt';
import { EventService } from './services/eventService';
import { PreferenceService } from './services/preferenceService';
import { RequestService } from './services/requestService';
import { AccountSecurityPromptContextProvider } from './store/contextProvider';

/**
 * Core parameters provided by the experimentation framework.
 */
type Props = {
  promptType: PromptType;
  viewType: ViewType;
  dismissOption: DismissOption;
  isUserUnder13: boolean;
  eventService: EventService;
  preferenceService: PreferenceService;
  requestService: RequestService;
} & WithTranslationsProps;

const App: React.FC<Props> = (props: Props) => {
  const {
    promptType,
    viewType,
    dismissOption,
    isUserUnder13,
    eventService,
    preferenceService,
    requestService,
    translate
  } = props;

  return (
    <AccountSecurityPromptContextProvider
      promptType={promptType}
      viewType={viewType}
      dismissOption={dismissOption}
      isUserUnder13={isUserUnder13}
      eventService={eventService}
      preferenceService={preferenceService}
      requestService={requestService}
      translate={translate}>
      <AccountSecurityPromptContainer />
    </AccountSecurityPromptContextProvider>
  );
};

export default withTranslations(App, TRANSLATION_CONFIG);
